"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const context_1 = require("@apollo/client/link/context");
const subscriptions_1 = require("@apollo/client/link/subscriptions");
const utilities_1 = require("@apollo/client/utilities");
const graphql_ws_1 = require("graphql-ws");
const isomorphic_fetch_1 = tslib_1.__importDefault(require("isomorphic-fetch"));
const constant_1 = require("../constant");
const Publisher_1 = require("./Publisher");
class Client {
    constructor() {
        this.cache = new client_1.InMemoryCache();
        this.client = null;
        this.options = {
            enableSubscription: false,
        };
        this.clientPublisher = new Publisher_1.Publisher();
        this.initClient = () => {
            this.client = null;
            const baseUrl = this.options.baseUrl || constant_1.CURVO_URI;
            const protocol = this.options.protocol || (constant_1.env === 'PROD' ? 'https' : 'http');
            const wsProtocol = this.options.wsProtocol || (constant_1.env === 'PROD' ? 'wss' : 'ws');
            const getToken = this.options.getToken || (async () => '');
            const fetch = process.env.npm_package_name === '@curvo/landing-page' ? isomorphic_fetch_1.default : undefined;
            const httpLink = new client_1.HttpLink({
                uri: `${protocol}://${baseUrl}/graphql`,
                fetch,
            });
            let finalLink = httpLink;
            if (this.options.enableSubscription) {
                const wsLink = new subscriptions_1.GraphQLWsLink((0, graphql_ws_1.createClient)({
                    url: `${wsProtocol}://${baseUrl}/subscriptions`,
                    shouldRetry: () => true,
                    lazy: true,
                    connectionParams: async () => {
                        try {
                            const token = await getToken();
                            return {
                                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                            };
                        }
                        catch (_) {
                            // do nothing
                        }
                        return {};
                    },
                }));
                finalLink = (0, client_1.split)(({ query }) => {
                    const definition = (0, utilities_1.getMainDefinition)(query);
                    const isSubscription = definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
                    return isSubscription;
                }, wsLink, httpLink);
            }
            const authLink = (0, context_1.setContext)(async (_, { headers }) => {
                try {
                    const token = await getToken();
                    return {
                        headers: {
                            ...headers,
                            ...(token ? { Authorization: `Bearer ${token}` } : {}),
                        },
                    };
                }
                catch (__) {
                    // do nothing
                }
                return {
                    headers,
                };
            });
            this.client = new client_1.ApolloClient({
                link: authLink.concat(finalLink),
                cache: this.cache,
            });
            this.clientPublisher.publish(this.client);
        };
    }
    getClient() {
        if (!this.client) {
            this.initClient();
        }
        return this.client;
    }
    getUrl() {
        return this.options.baseUrl || constant_1.CURVO_URI;
    }
    configClient(options) {
        this.options = options;
        this.initClient();
    }
    clear() {
        console.info('Client reset');
        this.cache.reset();
        if (this.client) {
            this.client.clearStore();
        }
        this.client = null;
    }
}
const instance = new Client();
exports.default = instance;
